export default class EventListeners {
  constructor() {
    window.customEventListeners = window.customEventListeners || {};
    this.init = this.init.bind(this);
  }

  init() {
    this.initForYouProducts();
  }

  initForYouProducts() {
    document.addEventListener('nosto-for-you-products', (event) => {
      window.customEventListeners.nostoForYouProductsEvent = event;
    });
  }
}
